export default "<ul class=\"navbar-nav mr-auto\">\r\n  <li class=\"nav-item\">\r\n    <!-- <app-nav-search></app-nav-search> -->\r\n  </li>\r\n</ul>\r\n"